export enum DialogResult {
    OK,
    Cancel
}
